import {
  getConversionList,
  postSaveConversionRule,
  putUpdateConversionRule,
  deleteConversionRule,
} from 'features/Product/services/conversionRule'
import { getProductV2API } from 'utils/apiList/productV2'
import { AppDispatchType, RootStateType } from 'store'
import { callErrorMsg } from 'helpers/errorMsg'
import { toastSuccess } from 'utils/toast'
import { AxiosResponse } from 'axios'
import { FormDataType } from 'features/Product/pages/ConversionRule/ModalAddRule/FormSchema'
import {
  setConversionRuleList,
  setModalAddEditRule,
  resetModalAddEditRule,
  resetModalConfirmDelete,
  resetQueryParamSearch,
  setIsLoading,
} from './slice'

export const fetchConversionList =
  () => async (dispatch: AppDispatchType, getState: () => RootStateType) => {
    const { queryParams } = getState().conversionRule
    try {
      const {
        data: { data },
      } = await getConversionList(queryParams)

      const formattedData = data.map((item) => ({
        uniqueId: crypto.randomUUID(),
        ...item,
      }))
      dispatch(setConversionRuleList(formattedData))
    } catch (error) {
      callErrorMsg(error)
    }
  }

export const fetchProductList = (searchedName: string) => async (dispatch: AppDispatchType) => {
  try {
    const {
      data: { data },
    } = await getProductV2API({
      pageSize: 20,
      name: searchedName,
    })

    dispatch(setModalAddEditRule({ productList: data }))
  } catch (error) {
    callErrorMsg(error)
  }
}

const getDataForSubmit = (formData: FormDataType) => ({
  rule_name: formData.reference,
  type: formData.conversionType.value,
  product_origins: formData.skuOriginList.map((item) => ({
    product_id: item.selectedSku?.productID as never,
    quantity: item.qty ? +item.qty : 0,
  })),
  product_destinations: formData.skuDestinationList.map((item) => ({
    product_id: item.selectedSku?.productID as never,
    quantity: item.qty ? +item.qty : 0,
  })),
})

export const addConversionRule = (formData: FormDataType) => async (dispatch: AppDispatchType) => {
  const dataToSubmit = getDataForSubmit(formData)

  try {
    const { data } = (await postSaveConversionRule(dataToSubmit)) as unknown as AxiosResponse<{
      message: string
    }>
    dispatch(resetModalAddEditRule())
    dispatch(resetQueryParamSearch())
    dispatch(fetchConversionList())
    toastSuccess(data.message)
  } catch (error) {
    callErrorMsg(error)
  }
}

export const updateConversionRule =
  (id: number, formData: FormDataType) => async (dispatch: AppDispatchType) => {
    try {
      const dataToSubmit = getDataForSubmit(formData)

      const { data } = (await putUpdateConversionRule(
        id,
        dataToSubmit,
      )) as unknown as AxiosResponse<{ message: string }>
      dispatch(resetModalAddEditRule())
      dispatch(resetQueryParamSearch())
      dispatch(fetchConversionList())
      toastSuccess(data.message)
    } catch (error) {
      callErrorMsg(error)
    }
  }

export const removeConversionRule =
  () => async (dispatch: AppDispatchType, getState: () => RootStateType) => {
    const { id } = getState().conversionRule.modalConfirmDelete

    dispatch(setIsLoading(true))
    try {
      await deleteConversionRule(id)
      toastSuccess('Berhasil menghapus conversion rule')
      dispatch(resetModalConfirmDelete())
      dispatch(fetchConversionList())
    } catch (error) {
      callErrorMsg(error)
    } finally {
      dispatch(setIsLoading(false))
    }
  }
